import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingLayoutComponent } from './shared/components/landing-layout/landing-layout.component';

const routes: Routes = [
  {
    path:'',
    redirectTo:'home',
    pathMatch:'full'
  },
  {
    path:'home',
    component:LandingLayoutComponent
  },
  {
    path:'contracts',
    loadChildren : () => import('./contracts-awarded/contracts-awarded.module').then(c => c.ContractsAwardedModule)
  },
  {
    path:'supplierpayments',
    loadChildren : () => import('./supplier-payments/supplier-payments.module').then(c => c.SupplierPaymentsModule)
  },
  {
    path:'**',
    redirectTo:'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      initialNavigation: 'enabledNonBlocking',
      useHash: false,
      onSameUrlNavigation: 'reload'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
